var map = {
	"./Path 351.svg": 368,
	"./back-button.svg": 130,
	"./close-page-icon.svg": 78,
	"./improvement.svg": 84,
	"./new-scoring-icons/result-image.svg": 369,
	"./new-scoring-icons/svgicons/HT-0.svg": 370,
	"./new-scoring-icons/svgicons/HT-1.svg": 371,
	"./new-scoring-icons/svgicons/HT-2.svg": 372,
	"./new-scoring-icons/svgicons/HT-3.svg": 373,
	"./new-scoring-icons/svgicons/HT-4.svg": 374,
	"./new-scoring-icons/svgicons/IT-0.svg": 375,
	"./new-scoring-icons/svgicons/IT-1.svg": 376,
	"./new-scoring-icons/svgicons/IT-2.svg": 377,
	"./new-scoring-icons/svgicons/IT-3.svg": 378,
	"./new-scoring-icons/svgicons/IT-4.svg": 379,
	"./new-scoring-icons/svgicons/RT-0.svg": 380,
	"./new-scoring-icons/svgicons/RT-1.svg": 381,
	"./new-scoring-icons/svgicons/RT-2.svg": 382,
	"./new-scoring-icons/svgicons/RT-3.svg": 383,
	"./new-scoring-icons/svgicons/RT-4.svg": 384,
	"./new/pp-1.svg": 385,
	"./new/pp-10.svg": 386,
	"./new/pp-11.svg": 387,
	"./new/pp-12.svg": 388,
	"./new/pp-2.svg": 389,
	"./new/pp-3.svg": 390,
	"./new/pp-4.svg": 391,
	"./new/pp-5.svg": 392,
	"./new/pp-6.svg": 393,
	"./new/pp-7.svg": 394,
	"./new/pp-8.svg": 395,
	"./new/pp-9.svg": 396,
	"./not-applicable.svg": 43,
	"./ponder-bg-l.svg": 397,
	"./pp-1.svg": 398,
	"./pp-10.svg": 399,
	"./pp-11.svg": 400,
	"./pp-12.svg": 401,
	"./pp-2.svg": 402,
	"./pp-3.svg": 403,
	"./pp-4.svg": 404,
	"./pp-5.svg": 405,
	"./pp-6.svg": 406,
	"./pp-7.svg": 407,
	"./pp-8.svg": 408,
	"./pp-9.svg": 409,
	"./pp-b-1.svg": 91,
	"./pp-b-10.svg": 125,
	"./pp-b-11.svg": 126,
	"./pp-b-12.svg": 105,
	"./pp-b-2.svg": 92,
	"./pp-b-3.svg": 93,
	"./pp-b-4.svg": 77,
	"./pp-b-5.svg": 104,
	"./pp-b-6.svg": 121,
	"./pp-b-7.svg": 122,
	"./pp-b-8.svg": 123,
	"./pp-b-9.svg": 124,
	"./pp-bg-ipad-pro.svg": 410,
	"./pp-bg-ipad.svg": 411,
	"./pp-bg-l.svg": 128,
	"./pp-bg-m.svg": 127,
	"./pp-bg-xl.svg": 129,
	"./pp-ht-bg.svg": 412,
	"./pp-it-bg.svg": 413,
	"./pp-rt-bg.svg": 414,
	"./questor-white-logo.svg": 415,
	"./report-bg-1.svg": 416,
	"./report-screen1-bg.svg": 79,
	"./score/Practice Required.svg": 169,
	"./score/Scope for Improvement.svg": 170,
	"./score/Well done.svg": 171,
	"./score/etq-cube.svg": 54,
	"./score/ht-1.svg": 172,
	"./score/ht-2.svg": 173,
	"./score/ht-3.svg": 174,
	"./score/ht-4.svg": 175,
	"./score/ht-5.svg": 176,
	"./score/ht-rt-it.svg": 177,
	"./score/it-1.svg": 178,
	"./score/it-2.svg": 179,
	"./score/it-3.svg": 180,
	"./score/it-4.svg": 181,
	"./score/it-5.svg": 182,
	"./score/it-ht.svg": 183,
	"./score/rt-1.svg": 184,
	"./score/rt-2.svg": 185,
	"./score/rt-3.svg": 186,
	"./score/rt-4.svg": 187,
	"./score/rt-5.svg": 188,
	"./score/rt-ht.svg": 189,
	"./score/rt-it.svg": 190,
	"./thumbsup.svg": 83,
	"./tip-arrow-icon.svg": 61,
	"./white/pp-w-1.svg": 417,
	"./white/pp-w-10.svg": 418,
	"./white/pp-w-11.svg": 419,
	"./white/pp-w-12.svg": 420,
	"./white/pp-w-2.svg": 421,
	"./white/pp-w-3.svg": 422,
	"./white/pp-w-4.svg": 423,
	"./white/pp-w-5.svg": 424,
	"./white/pp-w-6.svg": 425,
	"./white/pp-w-7.svg": 426,
	"./white/pp-w-8.svg": 427,
	"./white/pp-w-9.svg": 428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;